import {
  type UserDocumentPosition,
  type UserDocumentPositionERx,
} from '@redteclab/api/clients/bully'

export const userSubOrderAccessorIsProductErx = (
  product: UserDocumentPosition & UserDocumentPositionERx,
): boolean => {
  return 'medicationType' in product
}
